import { useCallback, useMemo } from 'react'
import { useHistory } from 'react-router-dom'

import { IWallet } from '@/services/wallet/getWallet'
import { tokenToString } from '@/utils/token'
import { compactNumbers } from '@/utils/utils'

interface FeedRPKButtonProps {
  wallet: IWallet
}

export function FeedRPKButton({ wallet }: FeedRPKButtonProps) {
  const userHasRPKs = useMemo(() => wallet?.totalBalance !== '0', [wallet])
  const history = useHistory()
  const compactedValue = useMemo(() => {
    const value = wallet?.totalBalance ?? '0'
    const tokenValue = Number(tokenToString(value))

    return compactNumbers(Math.floor(tokenValue))
  }, [wallet])

  const handleOnClick = useCallback(() => {
    if (userHasRPKs) {
      history.push('/vault')
    }
  }, [userHasRPKs, history])

  return (
    <button
      id={userHasRPKs ? '' : 'feed-deposit-bottom-sheet'}
      className="border-r pr-3 border-cool-gray-700 cursor-pointer"
      onClick={handleOnClick}
    >
      <span className="font-bold text-base">{compactedValue}</span>{' '}
      <span className="font-bold text-primary">RPK</span>
    </button>
  )
}
